import React from "react";
import TextField from "@material-ui/core/TextField";
import InputRules from "./InputRules";
import {InputAdornment} from "@material-ui/core";

interface Props {
  testInterval: number;
  shape: number;
  scale: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>, error?: boolean) => void;
}

class WeibullInput extends React.Component<Props> {

  private handleTestIntervalChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { shape, scale, onChange } = this.props;
    const isTestIntervalValid = InputRules.isTestIntervalValid(e.target.value);
    const isShapeValid = InputRules.isShapeValid(shape);
    const isScaleValid = InputRules.isScaleValid(scale);
    onChange(e, !isTestIntervalValid || !isShapeValid || !isScaleValid);
  };

  private handleShapeChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { testInterval, scale, onChange } = this.props;
    const isTestIntervalValid = InputRules.isTestIntervalValid(testInterval);
    const isShapeValid = InputRules.isShapeValid(e.target.value);
    const isScaleValid = InputRules.isScaleValid(scale);
    onChange(e, !isTestIntervalValid || !isShapeValid || !isScaleValid);
  };

  private handleScaleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { shape, testInterval, onChange } = this.props;
    const isTestIntervalValid = InputRules.isTestIntervalValid(testInterval);
    const isShapeValid = InputRules.isShapeValid(shape);
    const isScaleValid = InputRules.isScaleValid(e.target.value);
    onChange(e, !isTestIntervalValid || !isShapeValid || !isScaleValid);
  };

  render() {

    const { testInterval, shape, scale } = this.props;
    const isTestIntervalValid = InputRules.isTestIntervalValid(testInterval);
    const isShapeValid = InputRules.isShapeValid(shape);
    const isScaleValid = InputRules.isScaleValid(scale);

    return (
      <React.Fragment>
        <TextField
          required
          label="Time"
          name="weibull_test_interval"
          InputProps={{
            startAdornment: <InputAdornment position="start">t</InputAdornment>,
          }}
          value={testInterval}
          type="number"
          onChange={this.handleTestIntervalChange}
          margin="normal"
          variant="outlined"
          error={!isTestIntervalValid}
          fullWidth
          helperText={isTestIntervalValid ? undefined : InputRules.DESCRIPTIONS.TEST_INTERVAL}
        />
        <TextField
          required
          label="Shape"
          InputProps={{
            startAdornment: <InputAdornment position="start">β</InputAdornment>,
          }}
          name="shape"
          value={shape}
          type="number"
          onChange={this.handleShapeChange}
          margin="normal"
          variant="outlined"
          error={!isShapeValid}
          fullWidth
          helperText={isShapeValid ? undefined : InputRules.DESCRIPTIONS.SHAPE}
        />
        <TextField
          required
          label="Scale"
          InputProps={{
            startAdornment: <InputAdornment position="start">η</InputAdornment>,
          }}
          name="scale"
          value={scale}
          type="number"
          onChange={this.handleScaleChange}
          margin="normal"
          variant="outlined"
          error={!isScaleValid}
          fullWidth
          helperText={isScaleValid ? undefined : InputRules.DESCRIPTIONS.SCALE}
        />
      </React.Fragment>
    );
  }
}

export default WeibullInput;
